import { Scene, Mesh, Color3, HighlightLayer, ShaderMaterial, Animation, MeshBuilder, Material, StandardMaterial, TransformNode } from '@babylonjs/core';
import { ModelLoader } from './../../loader/ModelLoader';
import { Noise } from '../../materials/particle/Noise';
import { DiffuseCircleMaterial } from './../../materials/diffuseCircle/DiffuseCircleMaterial';
import { GlobalObject } from '@/Engine/utils/GlobalObject';

export class HotPoint {
    private scene: Scene;
    private hp?: Mesh;
    private HL?: HighlightLayer;
    private speed: number = 0.1;
    private mat?: StandardMaterial;
    private pool: any[] = [];
    constructor(scene: Scene) {
        this.scene = scene;
        //this.HL = new HighlightLayer("hl1", this.scene);
    }
    public async init() {
        let loader = ModelLoader.instance;
        this.hp = await loader.getModel(GlobalObject.getInstance().main.source.common.hpoint) as Mesh;
        //this.scene.addMesh(this.hp);
        //this.hp.billboardMode = 7;
        this.hp.scaling.set(2, 2, 2);
        //this.hp.position.set(-230, 25, -10);
        //const noise:Noise = new Noise(this.scene, this.hp);
        let Mat1Instance: DiffuseCircleMaterial = DiffuseCircleMaterial.getInstance()
        Mat1Instance.init(this.scene, new Color3(0.1, 1.0, 1.0), new Color3(0.1, 1.0, 1.0))
        let mat1 = Mat1Instance.material as ShaderMaterial;
        let arr = this.hp.getChildren();
        for (let i = 0; i < arr.length; ++i) {
            let mesh = arr[i] as Mesh;
            if (mesh.name == 'cy1') {
                mesh.material = mat1;
                mesh.isPickable = false;
            }
            if (mesh.name == 'cy2') {
                mesh.isPickable = false;
            }
        }
        this.hp.setEnabled(false); // 隐藏

        this.mat = new StandardMaterial("hp_hitbox", this.scene);
        this.mat.diffuseColor = new Color3(0.5, 0.5, 0.5);
        this.mat.alpha = 0;
        // test
        /*
        const hl = new HighlightLayer("hl1", this.scene);
        hl.addMesh(this.hp.getChildren()[0] as Mesh, new Color3(0.6, 1.0, 1.0));

        let hp2 = this.hp.clone();
        this.scene.addMesh(hp2);
        hp2.position.set(-230, 25, 20);
        hl.addMesh(hp2.getChildren()[0] as Mesh, new Color3(0.6, 1.0, 1.0));
        */
    }
    public getObject() {
        if (this.pool.length > 0) {
            return this.pool.pop();
        } else {
            let point = this.clone() as any; // return a mesh
            this.addAnimation(point.getChildren()[0] as Mesh);
            return  point;
        }
    }
    public recycleObject(point:any) {
        if(point.parent){
            point.setEnabled(false);
            point.parent = null;
        }
        this.pool.push(point);
    }
    public clone() {
        if (this.hp) {
            let mesh = (this.hp as Mesh).clone();
            mesh.setEnabled(true);
            mesh.scaling.set(3, 3, 3);
            let facility_box = MeshBuilder.CreateBox("facility_box", { size: 2, width: 1, height: 1, depth: 1 }, this.scene);
            facility_box.setParent(mesh);
            facility_box.scaling.set(3, 3, 3);
            facility_box.position.y = 1;
            (facility_box as Mesh).material = this.mat as StandardMaterial;
            facility_box.isPickable = true;
            //(this.HL as HighlightLayer).addMesh(mesh.getChildren()[0] as Mesh, new Color3(0.6, 1.0, 1.0));
            return mesh;
        } else {
            console.log('we dont have original mesh.')
        }
    }
    public addAnimation(mesh: Mesh) {
        const frameRate = 30;
        const xSlide = new Animation("xSlide", "position.y", frameRate, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
        const keyFrames = [];
        keyFrames.push({
            frame: 0,
            value: 1
        });
        keyFrames.push({
            frame: frameRate,
            value: 1.7
        });
        keyFrames.push({
            frame: 2 * frameRate,
            value: 1
        });
        xSlide.setKeys(keyFrames);
        mesh.animations.push(xSlide);
        this.scene.beginAnimation(mesh, 0, 2 * frameRate, true);
    }
}